export default function SectionAbout() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
          关于天狼影院
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
          天狼影院成立于2020年，是国内领先的高清免费在线观影平台。我们致力于为影迷提供即点即播、不缓冲的流畅观影体验，汇聚海量最新电视剧、热门电影、综艺节目资源。平台持续优化播放技术，支持多端同步观看，让每一位用户随时随地享受高清影视盛宴。无论您是热衷追剧的剧迷，还是喜爱大片的电影爱好者，天狼影院都能满足您的观影需求。
        </p>
      </div>
    </section>
  );
}